import { clearLocalSession, getLocalSession, loadLocalState, localJoin, reduceLocal } from './local-repository';
import type { AppAction, AppState } from './types';

const useRemote = import.meta.env.PROD && import.meta.env.VITE_LOCAL_ONLY !== 'true';
const TOKEN_KEY = 'fan-dazi.remote-token.v1';
const apiBase = (import.meta.env.VITE_API_BASE_URL ?? '.').replace(/\/$/, '');

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const token = localStorage.getItem(TOKEN_KEY);
  const response = await fetch(`${apiBase}/api/${path}`, {
    ...init,
    headers: {
      'content-type': 'application/json',
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...init?.headers,
    },
  });
  const body = (await response.json()) as { success: boolean; data?: T; error?: { message: string } };
  if (!response.ok || !body.success || body.data === undefined) throw new Error(body.error?.message ?? '请求失败');
  return body.data;
}

export function hasSession(): boolean {
  return useRemote ? Boolean(localStorage.getItem(TOKEN_KEY)) : Boolean(getLocalSession());
}

export async function join(code: string, displayName: string, avatar: string, avatarColor: string): Promise<AppState> {
  if (!useRemote) {
    if (code.trim() !== '625') throw new Error('体验邀请码为 625');
    return localJoin(displayName, avatar, avatarColor);
  }
  const result = await request<{ token: string; state: AppState }>('join', {
    method: 'POST', body: JSON.stringify({ code, displayName, avatar, avatarColor }),
  });
  localStorage.setItem(TOKEN_KEY, result.token);
  return result.state;
}

export async function getState(): Promise<AppState> {
  if (!useRemote) {
    const state = loadLocalState();
    if (!state) throw new Error('请重新加入');
    return state;
  }
  return request<AppState>('state');
}

export async function dispatch(state: AppState, action: AppAction): Promise<AppState> {
  if (!useRemote) return reduceLocal(state, action);
  return request<AppState>('action', { method: 'POST', body: JSON.stringify(action) });
}

export function logout(): void {
  localStorage.removeItem(TOKEN_KEY);
  clearLocalSession();
}
